<template>
    <div class="loader loader2 large"></div>
</template>
<script>
export default {};
</script>

<style lang="scss">
.loader {
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 10px 20px;
}
@keyframes load2 {
    50% {
        transform: rotatez(180deg);
        border-radius: 55%;
    }
    100% {
        transform: rotatez(360deg);
    }
}
.loader2::before {
    content: '';
    color: white;
    height: 30px;
    width: 30px;
    background: transparent;
    border-radius: 10%;
    border: 25px inset orange;
    animation: load2 1s infinite ease-in-out;
}

.large.loader2::before {
    height: 100px;
    width: 100px;
    border: 35px inset orange;
}
</style>


// WEBPACK FOOTER //
// front/src/skins/xkiosk/components/_base/loading/africa/loading.vue